import React, { useState, useEffect, useRef } from 'react';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { filter, multiDelete } from '../../../../Services/checklistService';
import { getStages } from '../../../../Services/optionService';
import { Dialog } from 'primereact/dialog';
import { getCustomerControlField } from '../../../../Services/customerServices';
import HeaderSearchBar from '../../../../Components/UiComponents/HeaderSearch';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import CreateNewCheckList from './CreateNewCheckList';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import EditCheckList from './EditCheckList';
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from 'react-router-dom';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import { getCustomerFields } from '../../../../Services/fieldsServices';

export default function CheckLists(props) {
  const [customerId, setCustomerId] = useState(null);
  const [custmerReferenceData, setCustmerReferenceData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [position, setPosition] = useState('center');
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [stages, setStages] = useState([]);
  const [updatedReferenceData, setUpdatedReferenceData] = useState([]);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [deleteClistIds, setDeleteClistIds] = useState([]);
  const [editClist, setEditClist] = useState([]);
  const [fieldTabs, setFieldTabs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleted, setDeleted] = useState(false)
  const [showVideo, setShowVideo] = useState(false);
  const [havingBranch, setHavingBranch] = useState(false);
  const [branchIdFromLS, setBranchIdFromLS] = useState();

  const navigate = useNavigate()
  const toastRef = useRef();
  // Pagination
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: -1,
    sortField: 'checklist_item',
    sortOrder: 1
  });

  useEffect(() => {
    if (deleted) {
      setDeleted(false);
      setDeleteClistIds([]);
      setUpdatedReferenceData([])
    }
  }, [deleted])

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");
    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);
      // Extracting customer information from end user data
      const customer = enduser.customer;
      // Setting customer ID state
      setCustomerId(customer);

      const branch = enduser.branch;
      setBranchIdFromLS(branch)
    } else {
      // Logging if no end user data found in local storage
      navigate("/login")
      localStorage.clear()
    }
    // Fetching stage data
    getStage();
  }, []);

  useEffect(() => {
    // Fetching customer field data
    getCustomerField();
    // Fetching customer control data
    getCustomerControl();
    // Fetching customer branch
    getCustomerBranch()

  }, [customerId]);

  useEffect(() => {
    getCustomerField();
  }, [lazyParams])

  // Function to fetch and set stages data
  const getStage = async () => {
    try {
      // Fetch stages data from API
      const stagesResponse = await getStages();
      // Extract and set stages data
      setStages(stagesResponse?.data[0]?.option_choice);
    } catch (error) {
      // Log and handle errors
      toastRef.current.showToast({
        type: 'error',
        message: "Failed to fetch stages data"
      });
    }
  };

  // Function to fetch customer fields data from the server
  const getCustomerField = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      // Ensure customerId is not null
      if (customerId !== null) {
        const { first, rows, sortField, sortOrder } = lazyParams;
        const skip = first;
        const limit = rows;
        const orderBy = sortField;
        const sortBy = sortOrder;
        const pattern = searchQuery || ''
        //skip, limit, cust_id, pattern, sortBy, orderBy
        const customerDAta = await filter(skip, limit, customerId, pattern, orderBy, sortBy)
        // Set the reference data in the state
        setCustmerReferenceData(customerDAta?.data?.checklist);
        setTotalRecords(customerDAta?.data?.count);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Check if customerId is available
      if (customerId !== null) {
        // Fetch customer control field data
        const customerData = await getCustomerControlField(customerId);
        // Extract and set customer control fields
        const controlFields = customerData?.data?.cust[0].modules[0];
        const fieldTabs = controlFields.tabs.filter(tab => tab.tab_name === 'Checklist');
        setFieldTabs(fieldTabs[0].tables[0].headers)
        setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  
  const getCustomerBranch = async () => {
    try {
        if (customerId === null) {
            return;
        }
        // Check if customerId is available
        if (customerId !== null) {
            // Fetch customer control field data
            const customerData = await getCustomerFields(customerId);
            // Extract and set customer control fields
            if(customerData && customerData.data){
                setHavingBranch(customerData.data.havingBranch)
            }
        }
    } catch (error) {
        toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred. Please try again or Contact Admin.'
        });
    }
};

  const checkingDisplayName = (rowData) => {
    return (
      <div>
        {
          <div>
            {rowData.checklist_item != null && rowData.checklist_item != '' ? rowData.checklist_item : rowData.checklist_item}
          </div>
        }
      </div>
    )
  }

  const promptType = (rowData) => {
    return (
      <div>
        {
          <div>
            {(rowData.checklist_type)}
          </div>
        }
      </div>
    )
  }

  const workStage = (rowData) => {
    return (
      <div>
        {
          <div>
            {rowData.winwork_display}
          </div>
        }
      </div>
    );
  }

  // Define column configuration for the data table
  const columns = [
    {
      field: "checklist_item", // Field name for the column data
      header: fieldTabs[0]?.display_name ? fieldTabs[0]?.display_name : '', // Header text displayed in the table header
      body: checkingDisplayName, // Function to render the cell content for this column
      style: { width: "50%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: 'row-datatable',
      sortable: true
    },
    {
      field: "checklist_type",
      header: fieldTabs[1]?.display_name ? fieldTabs[1]?.display_name : '',
      body: promptType,
      headerClassName: "header-datatable",
      className: 'row-datatable',
      sortable: true
    },
    {
      field: "winwork_display",
      header: fieldTabs[2]?.display_name ? fieldTabs[2]?.display_name : '',
      body: workStage,
      headerClassName: "header-datatable",
      className: 'row-datatable',
      sortable: true
    }
  ];

  const show = (position) => {
    setPosition(position);
    setVisible(true);
  };

  const showEdit = (position) => {
    setPosition(position);
    setVisibleEdit(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e);
    setLazyParams({
      ...lazyParams,
      first: 0, // Reset to first page on new search
      page: 0
    });
  };

  const handleClearFilter = () => {
    setSearchQuery("");
    setLazyParams({
      ...lazyParams,
      first: 0, // Reset to first page on new search
      page: 0
    });
  };

  const handleHide = () => {
    setVisible(false);
    getCustomerField();
  }

  const handleHideEdit = () => {
    setVisibleEdit(false);
    getCustomerField();
  }

  const confirmDeleteProduct = () => {
    setDeleteProductDialog(true);
  };

  const deleteField = async () => {
    try {
      const deleteResponse = await multiDelete(deleteClistIds);
      if (deleteResponse && deleteResponse?.status === 200) {
        toastRef.current.showToast({
          type: 'warn',
          message: `${customerControlFields?.tabs[9].display_name} Deleted Successfully`
        });
      } else {
        toastRef.current.showToast({
          type: 'error',
          message: `Error: failed to delete ${customerControlFields?.tabs[9].display_name}`
        });
      }
      getCustomerField();
      setUpdatedReferenceData([])
      // Close the delete confirmation dialog
      setDeleteProductDialog(false);
      setDeleted(true)
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: "Failed to remove field"
      });
    }
  }

  /**
 * Removes a field from the customer reference data at the specified index.
 * @param {number} selectedIndex - The index of the field to be removed.
 * @param {Object} data - The updated data to be set after removal.
 */
  const removeField = async (selectedIndex, data) => {
    // Check if the selectedIndex is valid
    if (selectedIndex === -1) {
      return;
    }
    // Create a shallow copy of the customer reference data
    const updatedReferenceDatas = [...custmerReferenceData];
    // Remove the field at the specified index
    updatedReferenceDatas.splice(selectedIndex, 1);
    // Update the state with the new data
    setUpdatedReferenceData(data);
    // selected Ids for deletion
    setDeleteClistIds(data.map(item => (
      item._id
    )))
  };

  const rowClick = async (data) => {
    setEditClist(data);
    showEdit('right');
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };

  // Define the footer for the delete product dialog with action buttons
  const deleteProductDialogFooter = () => {
    return (
      <div className="cancel-footer">
        <div className='align-center justify-end pb-0'>
          <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
          <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
        </div>
      </div>
    );
  }

  const onPage = (event) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
  };

  const onSort = (e) => {
    let newSortField = e.sortField;
    let newSortOrder = e.sortOrder;
    // Check if the same column is clicked
    if (lazyParams.sortField === newSortField) {
      // If currently sorted ascending, switch to descending
      if (lazyParams.sortOrder === 1) {
        newSortOrder = -1; // Set to descending
      }
      // If currently sorted descending, remove sorting
      else if (lazyParams.sortOrder === -1) {
        newSortField = null; // Remove sorting
        newSortOrder = -1; // Remove sorting
      }
    }
    setLazyParams((prevParams) => ({
      ...prevParams,
      sortField: newSortField,
      sortOrder: newSortOrder,
    }));
  };

  // Handle button click to show the video and apply the blur effect
  const handleButtonClick = () => {
    setShowVideo(true);
  };

  // Handle closing of the video (can be done by clicking a close button or outside)
  const closeVideo = () => {
    setShowVideo(false);
  };

  return (
    <div className="group-table-component">
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="header-design ">
        <div>
          <p className="fs-16 fw-600 mar-b-3">{customerControlFields?.tabs[9]?.display_name}</p>
        </div>
        <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      <div className="group-table-buttons">
        <div className="delete-button">
          {
            updatedReferenceData.length > 0 &&
            <ButtonElement
              className="delete-button-icon"
              type="button"
              icon="pi pi-trash"
              onClick={() => confirmDeleteProduct()}
            />
          }
        </div>
        <div className="group-table-search">
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            onClick={handleClearFilter}
          />
          <ButtonElement
            className="clear-filter-button"
            type="button"
            icon="pi pi-plus"
            label="New"
            onClick={() => show("right")}
          />
        </div>
      </div>

      <CreateNewCheckList visible={visible} position={position} customerId={customerId} customerControlFields={customerControlFields} onHide={handleHide} havingBranch={havingBranch} branchIdFromLS={branchIdFromLS}/>
      <EditCheckList visible={visibleEdit} position={position} customerId={customerId} customerControlFields={customerControlFields} editClist={editClist} onHide={handleHideEdit} havingBranch={havingBranch} branchIdFromLS={branchIdFromLS}/>

      <DataTable
        value={custmerReferenceData}
        columns={columns}
        searchQuery={searchQuery}
        removeField={removeField}
        rowClick={rowClick}
        lazyParams={lazyParams}
        totalRecords={totalRecords}
        onPage={onPage}
        dataKey="_id"
        isPrompts={true}
        onSort={onSort}
        deleted={deleted}

      />
      <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={`Delete ${customerControlFields && customerControlFields.tabs[9].display_name}`} modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog} className="table-dialog width-32" draggable={false}>
        <div className="confirmation-content">
          <span className="table-description">
            Are you sure you want to delete{' '}?
          </span>
        </div>
      </Dialog>

      <Dialog id="videoModal" visible={showVideo}
          breakpoints={{
          '1200px': '80vw',    // Larger modal on bigger screens
          '1024px': '85vw',    // Slightly smaller for medium screens
          '769': '90vw',     // Responsive on tablets
          '641px': '95vw',     // Almost full-width on mobile
          }}
          modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
      >
          <div className="video-overlay">
          <div className="video-container">
              <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_prompts" />
          </div>
          </div>
      </Dialog>
    </div>
  )
}